"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorInventoryAvailable = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const SensorInventoryAvailable = () => {
    const { options } = (0, hooks_1.useReactifySearchContext)();
    const flagsHook = (0, hooks_1.useFlags)();
    const { filterStack } = (0, hooks_1.useFilters)();
    if (!filterStack || "show_all" === filterStack.inventoryVisibility) {
        return null;
    }
    if (!flagsHook.flags["reactify-search:flag_sensor_inventoryavailable"]) {
        return null;
    }
    return (react_1.default.createElement(ReactiveComponent_1.default, { componentId: "SensorInventoryAvailable", customQuery: () => ({
            query: {
                bool: {
                    should: [
                        {
                            bool: {
                                must: [
                                    {
                                        term: {
                                            type: {
                                                value: "product",
                                            },
                                        },
                                    },
                                    {
                                        nested: {
                                            path: "variants",
                                            query: {
                                                match: { "variants.available": true },
                                            },
                                        },
                                    },
                                ],
                            },
                        },
                        ...(options.mode === "instant-search"
                            ? []
                            : [
                                {
                                    term: {
                                        type: {
                                            value: "callout",
                                        },
                                    },
                                },
                            ]),
                    ],
                    minimum_should_match: "1",
                },
            },
        }) }));
};
exports.SensorInventoryAvailable = SensorInventoryAvailable;
//# sourceMappingURL=SensorInventoryAvailable.js.map